/* @flow */
import Helmet from 'react-helmet'
import React from 'react'

const Title = ({ message }: any) => (
  <Helmet title={message} />
)

Title.propTypes = {
  message: React.PropTypes.string.isRequired,
}

export default Title



// WEBPACK FOOTER //
// ./src/browser/components/Title.js